/**
 * Canonical public origin for SEO, deep links, and JSON-LD.
 * Live canonical domain: aetherion-oracle.com (Aetherion Oracle lattice).
 */
export const SITE_ORIGIN =
  (typeof import.meta !== "undefined" &&
    (import.meta as ImportMeta & { env?: { VITE_SITE_URL?: string } }).env?.VITE_SITE_URL) ||
  "https://aetherion-oracle.com";

export const SITE_HOST = "aetherion-oracle.com";
export const SITE_APEX = "aetherion-oracle.com";

/** Absolute URL for a site path (leading slash optional). */
export function siteUrl(path = "/"): string {
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${SITE_ORIGIN.replace(/\/$/, "")}${p}`;
}
